import { render, staticRenderFns } from "./PersistTypeWebhookView.vue?vue&type=template&id=b188965e&"
import script from "./PersistTypeWebhookView.vue?vue&type=script&lang=ts&"
export * from "./PersistTypeWebhookView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports